import Step from 'components/global/Step'
import CabanaRow from 'components/shared/Reservation/ticketRows/Cabana'
//import MemoryCaptureRow from 'components/shared/Reservation/ticketRows/MemoryCapture'
import Info from 'components/shared/Info'
import InfoWrapper from 'components/shared/InfoWrapper'
import TicketsRow from 'components/shared/Reservation/ticketRows/Tickets'
import TransportRow from 'components/shared/Reservation/ticketRows/Transport'
import Section from 'components/shared/Section'
import { FormattedMessage, useIntl } from 'react-intl'
import { useAutoScroll } from 'utils/hooks'

import Box from 'components/shared/Box'
import SpaRow from 'components/shared/Reservation/ticketRows/SpaRow'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'store/hooks'
import { setDeliveryType } from 'store/order-slice'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import SelfcarePackages from 'routes/selfcare/views/SelfcareSummary/SelfcarePackages'

export type RemoteIdType =
    | 'manage-bundles'
    | 'manage-tickets'
    | 'manage-transport'
    | 'manage-cabanas'
    | 'manage-spa'
    | 'manage-memory-capture'

const SelfcareSummary = () => {
    const {
        tickets,
        spa,
        transport,
        cabanas,
        ticketsBundles,
        //memoryCapture,
    } = useAppSelector((state) => state.selfcare)
    const { countChanges, countNewItems, items } = useAppSelector(
        (state) => state.selfcareCart
    )

    const { cabanas: newCabanas, busTickets: newTransport } = items
    const { formatMessage } = useIntl()
    const { calculateScroll } = useAutoScroll()
    const { removeShipping } = useSelfcare()
    const dispatch = useDispatch()

    useEffect(() => {
        removeShipping()
        dispatch(setDeliveryType('email'))
    }, [])

    const handleEdit = (remoteId: RemoteIdType) => {
        calculateScroll({
            remoteId,
            trigerringSection: 'edit_order',
            trigerringAction: 'show',
            isRemote: true,
        })
    }

    const areAnyParkTickets = tickets && tickets.length > 0
    const areAnyBusTickets = newTransport.length || !!transport?.length
    const areAnyCabanas = newCabanas.length || !!cabanas?.length
    const areAnySpaTreatments = spa && spa.length > 0
    const isFamilyPackage = ticketsBundles && ticketsBundles.length > 0

    return (
        <Step
            title={formatMessage({
                id: 'selfcare.steps.caption_changes_summary',
                defaultMessage: 'Podsumowanie zmian',
            })}
            isButtonDisabled={!countChanges && !countNewItems}
            isButtonVisible={true}
        >
            <InfoWrapper gap={[16, 18]} padding={16}>
                <Info color="info_warning" hasNoPadding hasNoBackground>
                    <FormattedMessage
                        id="selfcare.summary.info_reservation"
                        defaultMessage="Zmienioną rezerwację o nowym numerze wyślemy na Twój adres e-mail po dokonaniu płatności."
                        key="reservation"
                    />
                </Info>
                <Info color="info_warning" hasNoPadding hasNoBackground>
                    <FormattedMessage
                        id="selfcare.summary.info_reimbursement"
                        defaultMessage="Zwrot środków otrzymasz w formie vouchera prezentowego do wykorzystania online lub na miejscu (np. w restauracji)."
                        key="reimbursement"
                    />
                </Info>
            </InfoWrapper>
            <Section>
                {isFamilyPackage && (
                    <SelfcarePackages mode="summary" handleEdit={handleEdit} />
                )}
                <Box gap={[24, 40]}>
                    {areAnyParkTickets && (
                        <TicketsRow
                            mode="summary"
                            handleEdit={handleEdit}
                            tickets={tickets}
                        />
                    )}
                    {!!areAnySpaTreatments && (
                        <SpaRow
                            mode="summary"
                            handleEdit={handleEdit}
                            spa={spa}
                        />
                    )}
                    {!!areAnyBusTickets && (
                        <TransportRow
                            mode="summary"
                            handleEdit={handleEdit}
                            transport={transport || []}
                        />
                    )}
                    {!!areAnyCabanas && (
                        <CabanaRow
                            mode="summary"
                            handleEdit={handleEdit}
                            cabanas={cabanas}
                        />
                    )}
                    {/*TODO: module disabled: MEMORY CAPTURE */}
                    {/*{memoryCapture &&*/}
                    {/*    memoryCapture.length > 0 && (*/}
                    {/*        <MemoryCaptureRow*/}
                    {/*            mode="summary"*/}
                    {/*            handleEdit={handleEdit}*/}
                    {/*            tickets={memoryCapture}*/}
                    {/*        />*/}
                    {/*    )}*/}
                </Box>
            </Section>

            {(!!areAnyBusTickets || !!areAnyCabanas) && !areAnyParkTickets && (
                <Info color="info">
                    <FormattedMessage
                        id="selfcare.summary.info_bus_tickets_only"
                        defaultMessage="Pamiętaj! Aby korzystać z{nbsp}atrakcji, potrzebujesz również biletu do{nbsp}parku. Bilety kupisz na{nbsp}parkofpoland.com lub{nbsp}na{nbsp}miejscu w{nbsp}kasie."
                        key="info_bus_tickets_only"
                        description="Please keep the html tags in the translation"
                        values={{
                            nbsp: <>&nbsp;</>,
                        }}
                    />
                </Info>
            )}
        </Step>
    )
}

export default SelfcareSummary
